import React, { useEffect } from "react";
import LibraryFolderPaths from "../../LibraryFolderPaths";
import { useNavigate } from "react-router-dom";
import { ImHome } from "react-icons/im";
import DropDownComp from "../../../components/DropDownComp";
import { BiLike } from "react-icons/bi";
import { BiSolidLike } from "react-icons/bi";
import { BiDislike } from "react-icons/bi";
import { BiSolidDislike } from "react-icons/bi";
import { useState } from "react";
import { useLikeDislikeMutation } from "../ViewWorkbbookAPISlice";
export default function ViewworkbookHeader1({
  workbookData,
  workbookId,
  setSubscribeModal,
  isEditButtonVisible,
  handleEditWorkbook,
  currentSheet,
  handleDownloadDataModal,
  handleCallFunction,
  setRegisterwithGoogleModal,
  isPublicDashboardTrue = false,
  openTutorialModal,
  tutorialModal,
}) {
  const [feedback, setFeedback] = useState(null); // "like", "dislike", or null
  const [numberOfLikes, setNumberOfLikes] = useState(workbookData.countLike);
  const [numberOfDislikes, setNumberOfDislikes] = useState(0);
  const [likeDislikeRequest, setLikeDislikeRequest] = useState(null);
  const [likeDislike, { data, isLoading, isError, error, isSuccess }] =
    useLikeDislikeMutation();
  const handleLike = () => {
    let newFeedback = feedback === "like" ? null : "like";
    let likeChange = null;
    let dislikeChange = null;

    if (feedback === "like") {
      // If already liked, remove like
      setNumberOfLikes((prev) => prev - 1);
      likeChange = "subtract";
    } else {
      // Add like
      setNumberOfLikes((prev) => prev + 1);
      likeChange = "add";

      if (feedback === "dislike") {
        // Remove dislike if it was previously active
        setNumberOfDislikes((prev) => prev - 1);
        dislikeChange = "subtract";
      }
    }

    setFeedback(newFeedback);
    setLikeDislikeRequest({ like: likeChange, dislike: dislikeChange });
  };

  const handleDislike = () => {
    let newFeedback = feedback === "dislike" ? null : "dislike";
    let likeChange = null;
    let dislikeChange = null;

    if (feedback === "dislike") {
      // If already disliked, remove dislike
      setNumberOfDislikes((prev) => prev - 1);
      dislikeChange = "subtract";
    } else {
      // Add dislike
      setNumberOfDislikes((prev) => prev + 1);
      dislikeChange = "add";

      if (feedback === "like") {
        // Remove like if it was previously active
        setNumberOfLikes((prev) => prev - 1);
        likeChange = "subtract";
      }
    }

    setFeedback(newFeedback);
    setLikeDislikeRequest({ like: likeChange, dislike: dislikeChange });
  };
  useEffect(() => {
    console.log(likeDislikeRequest);
    if (likeDislikeRequest) {
      const request = { workbookId, ...likeDislikeRequest };
      console.log(request);
      likeDislike(request);
    }
  }, [likeDislikeRequest]);

  console.log(currentSheet);
  console.log(isPublicDashboardTrue);
  const navigate = useNavigate();
  if (isPublicDashboardTrue) {
    return (
      // public dashboard
      <section className="flex items-center justify-between px-3 border-b-2 rounded py-1 z-10 h-auto w-full">
        <img
          src="/graph_img/viztaLogoAllBlue.png"
          alt="brand_logo"
          className="h-8 cursor-pointer"
        />
        <div className="font-semibold tracking-wide text-xs sm:text-sm md:text-base lg:text-xl">
          {workbookData.name}
        </div>
        <div className="flex items-center justify-end gap-2 sm:gap-3 md:gap-4 w-auto h-full">
          <div className="flex items-center justify-center font-medium border border-black rounded h-full">
            <button
              className={`flex items-center gap-1 text-sm font-medium px-2 h-full py-[5px] border-r-[1px] border-black ${
                feedback === "like" ? "text-blue-600" : ""
              }`}
              onClick={handleLike}
            >
              {feedback === "like" ? (
                <BiSolidLike className="text-lg" />
              ) : (
                <BiLike className="text-lg" />
              )}
              {numberOfLikes}
            </button>

            <button
              className={`font-medium px-2 h-full py-1 ${
                feedback === "dislike" ? "text-red-600" : ""
              }`}
              onClick={handleDislike}
            >
              {feedback === "dislike" ? (
                <BiSolidDislike className="text-lg" />
              ) : (
                <BiDislike className="text-lg" />
              )}
            </button>
          </div>
          {tutorialModal && (
            <button
              className="font-medium border border-black rounded sm:px-3 md:px-5 text-xs sm:text-sm h-full py-1"
              onClick={openTutorialModal}
            >
              Tutorial
            </button>
          )}
          <button
            className="font-medium border border-black rounded sm:px-3 md:px-5 text-xs sm:text-sm h-full py-1"
            onClick={() => setRegisterwithGoogleModal(true)}
          >
            Register & Edit
          </button>
        </div>
      </section>
    );
  } else {
    // private dashboard
    return (
      <section className="flex items-center justify-between px-3 border-b-2 rounded py-1 z-10 h-[5%] md:h-auto">
        <div className="flex items-center justify-center gap-2">
          <button
            className="flex items-center justify-start gap-1"
            onClick={() => navigate("/home/dash")}
          >
            <ImHome />
          </button>
          <LibraryFolderPaths isFolderPresentInLibrary={false} />
        </div>

        <div className="font-semibold tracking-wide text-xs sm:text-sm md:text-base lg:text-xl text-center break-words md:block sm:hidden">
          {workbookData.name}
        </div>

        <div className="flex items-center justify-end gap-2 sm:gap-3 md:gap-4 w-auto h-full">
          {/* <button
            className="border border-blue-950 rounded md:py-1 sm:px-3 md:px-5 text-xs sm:text-sm text-blue-950 h-full"
            onClick={() => setSubscribeModal(true)}
          >
            Subscribe
          </button> */}
          {isEditButtonVisible && (
            <button
              className="border border-blue-950 rounded md:py-1 sm:px-3 md:px-5 text-xs sm:text-sm text-blue-950 h-full"
              onClick={handleEditWorkbook}
            >
              Edit
            </button>
          )}
          {currentSheet.SheetType === "dashboard" ? null : <button
            className="border border-blue-950 rounded md:py-1 sm:px-3 md:px-5 text-xs sm:text-sm bg-blue-950 text-white h-full"
            onClick={() => {
              currentSheet.SheetType === "dashboard"
                ? handleDownloadDataModal()
                : handleCallFunction();
            }}
          >
            Download
          </button>}
          <DropDownComp />
        </div>
      </section>
    );
  }
}
